import { render, staticRenderFns } from "./PackageInfoForm.vue?vue&type=template&id=226c8812&"
import script from "./PackageInfoForm.vue?vue&type=script&lang=ts&"
export * from "./PackageInfoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports